/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Nav_Theme_DarkInputs */

const en_common_nav_theme_dark = /** @type {(inputs: Common_Nav_Theme_DarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dark`)
};

const zh_common_nav_theme_dark = /** @type {(inputs: Common_Nav_Theme_DarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`深色模式`)
};

/**
* | output |
* | --- |
* | "Dark" |
*
* @param {Common_Nav_Theme_DarkInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_nav_theme_dark = /** @type {((inputs?: Common_Nav_Theme_DarkInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Nav_Theme_DarkInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_nav_theme_dark(inputs)
	return zh_common_nav_theme_dark(inputs)
});
export { common_nav_theme_dark as "common.nav.theme_dark" }